/* Product page upsells (snippets/pdp-upsell.liquid, pdp-upsell-group.liquid).
   - Shows the upsell group that belongs to the selected variant.
   - Updates a card's price, link and Add button when its option changes.
   - Adds to the basket with /cart/add.js (no redirect): "Adding…" → "Added"
     with a tick → "Add" after 2 s; refreshes the basket count, drawer and
     delivery bar through window.FAWPCart.refresh (assets/cart.js).
   - Errors (e.g. not enough stock) show under the card.
   - "Show N more" reveals the rest (aria-expanded).
   - Fires an analytics event on each add: document "fawp:upsell-added",
     Shopify.analytics.publish('fawp_upsell_added') and dataLayer
     'upsell_added', with the product, variant and position. */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var TICK = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M3 8.5l3.2 3.2L13 5"/></svg>';

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function cardOf(el) { return el.closest('[data-pdp-upsell-card]'); }
  function groupOf(el) { return el.closest('[data-pdp-upsell]'); }

  function setError(card, msg) {
    var e = card.querySelector('[data-pdp-upsell-error]');
    if (!e) return;
    e.textContent = msg || '';
    e.hidden = !msg;
  }
  function announce(card, msg) {
    var live = groupOf(card) && groupOf(card).querySelector('[data-pdp-upsell-live]');
    if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); }
  }
  function titleOf(card) {
    var t = card.querySelector('.pdp-upsell__title');
    return t ? t.textContent.trim() : '';
  }

  /* ---------- Group for the selected variant ---------- */
  function syncGroups() {
    var groups = all('[data-pdp-upsell]');
    if (!groups.length) return;
    var input = document.querySelector('[data-variant-id]');
    var id = input && input.value;
    if (!id) return;
    groups.forEach(function (g) {
      var ids = (g.getAttribute('data-variants') || '').split(',');
      g.hidden = ids.indexOf(String(id)) === -1;
    });
  }

  /* ---------- Option change on a card ---------- */
  function onSelect(sel) {
    var card = cardOf(sel);
    var opt = sel.options[sel.selectedIndex];
    if (!card || !opt) return;
    var inc = card.querySelector('[data-pdp-upsell-inc]');
    var ex = card.querySelector('[data-pdp-upsell-ex]');
    var btn = card.querySelector('[data-pdp-upsell-add]');
    var link = card.querySelector('.pdp-upsell__title');
    if (inc) inc.textContent = opt.getAttribute('data-inc');
    if (ex) ex.textContent = opt.getAttribute('data-ex') + ' (Exc VAT)';
    if (link && opt.getAttribute('data-url')) link.setAttribute('href', opt.getAttribute('data-url'));
    setError(card, '');
    if (!btn) return;
    btn.setAttribute('data-variant-id', opt.value);
    if (btn.getAttribute('aria-busy') === 'true') return;
    if (opt.getAttribute('data-available') === 'true') {
      btn.disabled = false;
      btn.textContent = 'Add';
      btn.setAttribute('aria-label', 'Add ' + titleOf(card) + ' to basket');
    } else {
      btn.disabled = true;
      btn.textContent = 'Out of stock';
      btn.removeAttribute('aria-label');
    }
  }

  /* ---------- Analytics ---------- */
  function track(card, variantId) {
    var group = groupOf(card);
    var cards = group ? all('[data-pdp-upsell-card]', group) : [];
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    var detail = {
      source_product_id: meta && meta.id ? Number(meta.id) : null,
      upsell_product_id: Number(card.getAttribute('data-product-id')),
      upsell_variant_id: Number(variantId),
      position: cards.indexOf(card) + 1
    };
    try { document.dispatchEvent(new CustomEvent('fawp:upsell-added', { detail: detail })); } catch (e) { /* old browser */ }
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('fawp_upsell_added', detail); } catch (e) { /* no pixel API */ }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'upsell_added', source_product_id: detail.source_product_id, upsell_product_id: detail.upsell_product_id, upsell_variant_id: detail.upsell_variant_id, upsell_position: detail.position });
    } catch (e) { /* ignore */ }
  }

  /* ---------- Add to basket ---------- */
  function add(btn) {
    var card = cardOf(btn);
    var id = btn.getAttribute('data-variant-id');
    if (!card || !id) return;
    setError(card, '');
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding…';

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }, function () { return { ok: r.ok, d: null }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = res.d && (res.d.description || res.d.message);
          throw new Error(msg || 'Sorry, this could not be added. Please try again.');
        }
        btn.innerHTML = TICK + '<span>Added</span>';
        btn.classList.add('is-added');
        announce(card, titleOf(card) + ' added to your basket');
        try { if (window.FAWPCart && typeof window.FAWPCart.refresh === 'function') window.FAWPCart.refresh(); } catch (e) { /* display only */ }
        track(card, id);
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = 'Add';
          btn.removeAttribute('aria-busy');
        }, 2000);
      })
      .catch(function (err) {
        setError(card, (err && err.message) || 'Sorry, this could not be added. Please try again.');
        btn.textContent = 'Add';
        btn.removeAttribute('aria-busy');
      });
  }

  /* ---------- Wiring ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('[data-pdp-upsell-select]');
    if (sel) onSelect(sel);
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var toggle = e.target.closest('[data-pdp-upsell-toggle]');
    if (toggle) {
      var more = document.getElementById(toggle.getAttribute('aria-controls'));
      var open = toggle.getAttribute('aria-expanded') === 'true';
      if (more) more.hidden = open;
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.textContent = open ? toggle.getAttribute('data-more-label') : toggle.getAttribute('data-less-label');
      return;
    }
    var btn = e.target.closest('[data-pdp-upsell-add]');
    if (btn) {
      e.preventDefault();
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      add(btn);
    }
  });

  /* The variant picker (assets/product.js) updates [data-variant-id] in its
     own click/change handlers; read it once they have run. */
  var picker = document.querySelector('[data-variant-picker]');
  if (picker) {
    picker.addEventListener('click', function () { setTimeout(syncGroups, 0); });
    picker.addEventListener('change', function () { setTimeout(syncGroups, 0); });
  }
  window.addEventListener('pageshow', syncGroups);
})();
